import React from 'react';

import { Layout } from './src/components/Layout';
import { Provider } from './src/components/Provider';

export const wrapPageElement = ({ element, props }, pluginOptions) => {
  return (
    <Layout {...props} pluginOptions={pluginOptions}>
      {element}
    </Layout>
  );
};

export const wrapRootElement = ({ element, props }, pluginOptions) => {
  return (
    <Provider {...props} pluginOptions={pluginOptions}>
      {element}
    </Provider>
  );
};

export const onRenderBody = ({ setHeadComponents }) => {
  setHeadComponents([
    <link
      key="sitemap"
      title="Sitemap"
      // eslint-disable-next-line react/no-invalid-html-attribute
      rel="sitemap"
      type="application/xml"
      href="https://img.ly/sitemap.xml"
    />,
  ]);
};
